import { render, staticRenderFns } from "./PhoneNumber.vue?vue&type=template&id=75aca18a"
import script from "./PhoneNumber.vue?vue&type=script&lang=js"
export * from "./PhoneNumber.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./PhoneNumber.vue?vue&type=style&index=0&id=75aca18a&prod&lang=css")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

export default component.exports